import FormattedMessage from 'I18n/components/FormattedMessage';
import { BaseSaveViewActionButton } from './BaseSaveViewActionButton';
import { UndoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "viewsManagement.saveViewButtons.tooltips.reset"
});
export const ResetButton = ({
  isModifiedView,
  onClick
}) => /*#__PURE__*/_jsx(BaseSaveViewActionButton, {
  disabled: !isModifiedView,
  "data-test-id": "save-view-buttons__reset",
  onClick: onClick,
  use: "tertiary-extra-light",
  tooltip: tooltip,
  children: /*#__PURE__*/_jsx(UndoIcon, {
    size: "200"
  })
});